import { Request } from '../../Servidor/Request';

export class AddressRelatoryInteractor {
    public fetchAddress(filters: Array<any>): PromiseLike<any> {
        return new Promise((res, rej) => {
            return new Request().requestPost("relatorio/endereco/listagem", { ...filters }).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }

                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }

    public fetchAddressRelatory(filters: Array<any>): PromiseLike<any> {
        let name = 'Relatório_endereços.pdf'
        return new Promise((res, rej) => {
            return new Request().requestPdf("relatorio/endereco/pdf", { ...filters }, name).then((rs) => {
                if (rs == undefined) {
                    return rej({
                        Mensagem: "Erro ao conectar"
                    })
                }
                res(rs.Resultado)
            }, e => {
                rej(e);
            });
        });
    }
}